import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { customStyle } from '../../../Components/Style';
import SummaryIcon from '../../../Assets/Images/Employee/Summery';
import AttendanceByMemberIcon from '../../../Assets/Images/Attendance/AttendanceByMember';
import AttendanceByHourIcon from '../../../Assets/Images/Attendance/AttendancebyHour';
import AttendanceByTaskHourIcon from '../../../Assets/Images/Attendance/AttendanceByTaskHour';
import AttendanceByMapIcon from '../../../Assets/Images/Attendance/AttendanceByMap';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import '../../../Assets/Css/EmpAttendance.scss';
import EmpAttendanceSummery from './EmpAttendanceSummery';
import EmpAttendanceDetails from './EmpAttendanceDetails';
import EmpAttendanceByMember from './EmpAttendanceByMember';
import EmpAttendanceByHour from './EmpAttendanceByHour';
import EmpAttendanceByLocation from './EmpAttendanceByLocation';
import { getAllAttendance } from '../../../Services/Attendance/action';
import { connect } from 'react-redux';
import { getLeaves } from '../../../Services/Leave/action';
import { Spinner } from 'react-bootstrap';
import { generateYearOptions, Month } from '../../../Lib/utils';
import { getUsers } from '../../../Services/Users/action';
import Skeleton from 'react-loading-skeleton';
import { getTasks } from '../../../Services/Task/action';
import EmpTaskByHour from './EmpTaskByHour';

const AttendanceData = [
    { value: 'Holiday', label: 'Holiday' },
    { value: 'Present', label: 'Present' },
    { value: 'Half Day', label: 'Half Day' },
    { value: 'Late', label: 'Late' },
    { value: 'Absent', label: 'Absent' },
    { value: 'On Leave', label: 'On Leave' },
];

function EmpAttendance(props) {
    const [exportLoading, setExportrLoading] = useState(false);
    const [activeButton, setActiveButton] = useState('');
    const [users, setUsers] = useState()
    const [selectedUser, setSelectedUser] = useState(null);

    const fetchData = async () => {
        await props?.getAllAttendance();
        await props?.getLeaves();
        await props?.getUsers();
        await props?.getTasks();
    }

    useEffect(() => {
        fetchData();
    }, [])

    useEffect(() => {
        const userData = props.users.map((item) => ({
            value: item.name,
            label: item.name,
            id: item.id,
        }));
        setUsers(userData);
    }, [props.users]);

    const Year = generateYearOptions();
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().toLocaleString('en-US', { month: 'long' })
    const [selectFilters, setSelectedFilters] = useState({
        Year: { value: currentYear, label: currentYear },
        Late: '',
        Month: { value: currentMonth, label: currentMonth },
    });

    console.log("selectFilters ", selectFilters)

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname == '/attendance/empattendance') {
            const path = location.pathname.slice(12);
            setActiveButton(path);
        } else if (location.pathname == '/attendance/empmember') {
            const path = location.pathname.slice(12);
            setActiveButton(path);
        } else if (location.pathname == '/attendance/empbyhour') {
            const path = location.pathname.slice(12);
            setActiveButton(path);
        }
    }, [location.pathname]);


    const handleClick = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
    };

    const handleClear = () => {
        setSelectedFilters({
            Year: { value: currentYear, label: currentYear },
            Late: '',
            Month: { value: currentMonth, label: currentMonth },
        });
        setSelectedUser(null)
    }
    return (
        <div className="task-viewEmployee-main">
            <div className="page-title">
                {
                    props.loading ? (
                        <Skeleton className='rounded-2' width={200} height={40} />
                    ) : (
                        <h4>Attendance</h4>
                    )
                }
            </div>


            <div className="row">
                {location.pathname == '/attendance/empdetails' ? (
                    <></>
                ) : (
                    <>
                        {location.pathname == '/attendance/empbylocation' ? (<></>) : (
                            <>
                                <div className="col-lg-3 col-sm-12">
                                    {
                                        props.loading ? (
                                            <Skeleton className='rounded-2' width="100%" height={40} />
                                        ) : (
                                            <div className="card-type">
                                                <Select
                                                    value={selectFilters.Month}
                                                    onChange={(data) =>
                                                        setSelectedFilters({
                                                            ...selectFilters,
                                                            Month: data,
                                                        })
                                                    }
                                                    options={Month}
                                                    placeholder={'Month'}
                                                    styles={customStyle}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#5757fe',
                                                            primary: '#5757fe',
                                                        },
                                                    })}
                                                />
                                            </div>
                                        )
                                    }
                                </div>

                                <div className="col-lg-3 col-sm-12">
                                    {
                                        props.loading ? (
                                            <Skeleton className='rounded-2' width="100%" height={40} />
                                        ) : (
                                            <div className="card-type">
                                                <Select
                                                    value={selectFilters.Year}
                                                    onChange={(data) =>
                                                        setSelectedFilters({
                                                            ...selectFilters,
                                                            Year: data,
                                                        })
                                                    }
                                                    options={Year}
                                                    placeholder={'Year'}
                                                    styles={customStyle}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#5757fe',
                                                            primary: '#5757fe',
                                                        },
                                                    })}
                                                />
                                            </div>
                                        )
                                    }
                                </div>

                                <div className="col-lg-3 col-sm-12">
                                    {
                                        props.loading ? (
                                            <Skeleton className='rounded-2' width="100%" height={40} />
                                        ) : (
                                            <div className="card-type">
                                                <Select
                                                    value={selectFilters.Late}
                                                    onChange={(data) =>
                                                        setSelectedFilters({
                                                            ...selectFilters,
                                                            Late: data,
                                                        })
                                                    }
                                                    options={AttendanceData}
                                                    placeholder={'Late'}
                                                    styles={customStyle}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#5757fe',
                                                            primary: '#5757fe',
                                                        },
                                                    })}
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                            </>
                        )}

                        {props?.user?.role?.name?.includes('hr') &&
                            <div className="col-lg-3 col-sm-12" style={{ zIndex: 5, position: 'relative' }}>
                                {
                                    props.loading ? (
                                        <Skeleton className='rounded-2' width="100%" height={40} />
                                    ) : (
                                        <div className="card-type">
                                            <Select
                                                value={selectedUser}
                                                onChange={(data) => setSelectedUser(data)}
                                                options={users}
                                                placeholder='Select Employee'
                                                styles={{ ...customStyle }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#5757fe',
                                                        primary: '#5757fe',
                                                    },
                                                })}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        }

                        <div className='col-lg-1 cold-md-12'>
                            {/* <button
                                className="export-btn"
                                id="exportBtn"
                                disabled={!checked || exportLoading}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleClick(totalSelectedIds, "export");
                                }}
                            >
                                {exportLoading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        className="custom-spinner"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                Export
                                )}
                            </button> */}

                            {(selectFilters?.Year?.value !== currentYear || selectFilters?.Month?.value !== currentMonth || selectFilters?.Late || selectedUser) && (
                                <button
                                    className="export-btn"
                                    id="exportBtn"
                                    onClick={handleClear}
                                >Clear</button>
                            )}

                        </div>
                    </>
                )}

                <div className="col-md-12  attandance-btn mt-0">

                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" width={40} height={40} />
                        ) : (
                            <div className="navigation_btn">
                                <button
                                    className={`btn1 ${activeButton === "empattendance" ? "active" : ""}`}
                                    onClick={() => handleClick("empattendance", "/attendance/empattendance")}
                                >
                                    <SummaryIcon color={activeButton === "empattendance" ? "white" : "black"} bgColor={activeButton === "empattendance" ? "black" : "white"} />
                                </button>
                                <button
                                    className={`btn1 ${activeButton === "empmember" ? "active" : ""}`}
                                    onClick={() => handleClick("empmember", "/attendance/empmember")}
                                >
                                    <AttendanceByMemberIcon color={activeButton === "empmember" ? "white" : "black"} bgColor={activeButton === "empmember" ? "black" : "transparent"} />
                                </button>
                                <button
                                    className={`btn1 ${activeButton === "empbyhour" ? "active" : ""}`}
                                    onClick={() => handleClick("empbyhour", "/attendance/empbyhour")}
                                >
                                    <AttendanceByHourIcon color={activeButton === "empbyhour" ? "white" : "black"} bgColor={activeButton === "empbyhour" ? "black" : "white"} />
                                </button>
                                <button
                                    className={`btn1 ${activeButton === "emptaskbyhour" ? "active" : ""}`}
                                    onClick={() => handleClick("emptaskbyhour", "/attendance/emptaskbyhour")}
                                >
                                    <AttendanceByTaskHourIcon color={activeButton === "emptaskbyhour" ? "white" : "black"} bgColor={activeButton === "emptaskbyhour" ? "black" : "white"} />
                                </button>
                                <button
                                    className={`btn1 ${activeButton === "empbylocation" ? "active" : ""}`}
                                    onClick={() => handleClick("empbylocation", "/attendance/empbylocation")}
                                >
                                    <AttendanceByMapIcon color={activeButton === "empbylocation" ? "white" : "black"} bgColor={activeButton === "empbylocation" ? "black" : "transparent"} />
                                </button>
                            </div>
                        )
                    }

                </div>

                {
                    props.loading ? (
                        <div className="col-lg-12 col-md-12">
                            <Skeleton width="100%" height={100} className="rounded-2" />
                        </div>
                    ) : (
                        props?.user || props?.attendance?.length > 0 || props?.leave?.length > 0 ? (
                            <div className=" col-lg-12 col-md-12">
                                {location.pathname == '/attendance/empattendance' && <EmpAttendanceSummery data={props} selectFilters={selectFilters} selectedUser={selectedUser} />}
                                {location.pathname == '/attendance/empmember' && <EmpAttendanceByMember data={props} selectFilters={selectFilters} selectedUser={selectedUser} />}
                                {location.pathname == '/attendance/empdetails' && <EmpAttendanceDetails data={props} selectedUser={selectedUser} />}
                                {location.pathname == '/attendance/empbyhour' && <EmpAttendanceByHour data={props} selectFilters={selectFilters} selectedUser={selectedUser} />}
                                {location.pathname == '/attendance/emptaskbyhour' && <EmpTaskByHour data={props} selectFilters={selectFilters} selectedUser={selectedUser} />}
                                {location.pathname == '/attendance/empbylocation' && <EmpAttendanceByLocation data={props} selectedUser={selectedUser} />}
                            </div>
                        ) : (
                            <></>
                        )
                    )
                }
            </div >
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        loading: state.attendanceReducer.loading,
        attendance: state.attendanceReducer.attendance,
        user: state.authenticationReducer.user,
        leave: state.leaveReducer.leave,
        users: state.userReducer.users,
        task: state.taskReducer.task,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllAttendance: () => {
            dispatch(getAllAttendance())
        },
        getLeaves: () => {
            dispatch(getLeaves())
        },
        getUsers: () => {
            dispatch(getUsers())
        },
        getTasks: () => {
            dispatch(getTasks());
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EmpAttendance);
